export default __webpack_public_path__ + "static/media/the-tower@2x.bd05c716.png";